import React, {useEffect} from "react";
import helpersFunction from '../_helpers/helpersFunction';


export default function LanderAutologinSoloRedirect(props) {

    
    useEffect(() => {
               
     
        if(!props.reload){
            
                var token = localStorage.getItem('token')
                helpersFunction.eventPost(props.clickid,null,"clickOnMail")
                //helpersFunction.logToBackend("Codice notifica",{codiceNotifica:props.codiceNotifica})
                //helpersFunction.logToBackend("Pixel Click On Mail",{pixel:true,clickid:props.clickid,et:"clickOnMail"})
                try{
                    const tipo_notifica = props.codiceNotifica ? props.codiceNotifica : (props.contenutoMail ? props.contenutoMail : 'non_definito')
                    fetch(process.env.REACT_APP_APIADDRESS+"/users/"+props.clickid, {
                        method: 'get',
                        headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer '+ token,
                        'RemarketingClickid': props.remarketingClickid,
                        'tipoautologin':'email',
                        'eventoautologin':tipo_notifica,
                        }
                    })
                    .then(response => response.json())
                    .then(res => {
                        window.location.replace(props.red)
                    })
                    .catch((err)=>{
                        console.log("Errore chiamata landing autologin",err)
                        window.location.replace(props.red)
                    })
                }catch(err){
                    helpersFunction.logToBackend("Errore su recupero utente lander autologin",{err:err})
                }
       
            
           
        } 

        
	},[]); 

    return (
        <div>
            Redirecting...          
        </div>
        
 )

}